/**
 * Scarica un CSV con il punto e virgola, leggibile da Excel. Una cella che comincia con = + - @
 * diventerebbe una formula: si fa precedere da un apostrofo.
 */
export function scaricaCsv(nome: string, intestazioni: string[], righe: string[][]) {
  const campo = (v: string) => {
    const sicuro = /^[=+\-@]/.test(v) ? `'${v}` : v
    return /[;"\r\n]/.test(sicuro) ? `"${sicuro.replace(/"/g, '""')}"` : sicuro
  }
  const testo = `\ufeff${[intestazioni, ...righe].map((r) => r.map(campo).join(';')).join('\r\n')}\r\n`
  const indirizzo = URL.createObjectURL(new Blob([testo], { type: 'text/csv;charset=utf-8' }))
  const a = document.createElement('a')
  a.href = indirizzo
  a.download = nome
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(indirizzo), 1000)
}
